import { Navigate } from "react-router-dom";

import { useScope } from "@/hooks/useScope";

import { SettingsEntityView } from "./SettingsEntityView";

export function SettingsIndexRedirect() {
  const { entities, isLoadingAccounts } = useScope();
  const firstEntity = entities?.[0];

  // The first business's settings, drawn loading until the person's businesses
  // are read: sent on before then, settings always opened on the profile.
  if (isLoadingAccounts) {
    return <SettingsEntityView />;
  }

  if (firstEntity?.identifier) {
    return (
      <Navigate to={`/app/settings/entity/${firstEntity.identifier}`} replace />
    );
  }

  return <Navigate to="/app/settings/profile" replace />;
}
